import { Theme } from '@livecontrol/core-ui';
import { Matrix } from '@livecontrol/scheduler/components';
import React from 'react';
import styled from 'styled-components';
import type { GuestBook } from '../../../store';

import G = Matrix.Grid;
import H = G.Header;
import C = G.Row.Cell;

const GridContainer = styled.div`
  .header {
    color: #8798ad;
  }

  .row {
    div {
      border-color: #d5daea !important;
      align-items: flex-start;
    }
  }

  .guest-book-img {
    border-radius: 15px;
  }

  .delete-btn {
    width: 42px;
    height: 42px;
    border-radius: 6px;
    border: solid 1px #ff505f;
    background: transparent;
  }
  .icon {
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
  .trash {
    background-image: url(/assets/icons/Trash-red.svg);
  }
  .message-cell{
    flex-direction: column;
  }
  .read-more-text{
    padding: 1px 0px 0px 0px;
    text-decoration:underline;
    font-size: 12px;
    border: none;
    font-style: italic;
  }
`;

export const Grid = ({
  messages,
  deleteGuestBookMesage,
  showGuestBookMesage
}: {
  messages: GuestBook.GuestBookInterface.Message[];
  deleteGuestBookMesage: (messageId: string) => void;
  showGuestBookMesage: (messageId: string) => void;
}): React.ReactElement => {
  const viewport = Theme.useViewport();

  const handleDelete = (id: string): void => {
    deleteGuestBookMesage(id);
  };

  return (
    <GridContainer>
      <G viewport={viewport} gridTemplateColumns='1fr 1fr 1fr 1fr 2fr 1fr 1fr'>
        {/* Header */}
        <G.Row className='header'>
          <H viewport={viewport} className='font-size-12px font-weight-bold'>
            First Name
          </H>
          <H viewport={viewport} className='font-size-12px font-weight-bold'>
            Last Name
          </H>
          <H viewport={viewport} className='font-size-12px font-weight-bold'>
            Email
          </H>
          <H viewport={viewport} className='font-size-12px font-weight-bold'>
            Phone Number
          </H>
          <H viewport={viewport} className='font-size-12px font-weight-bold'>
            Message
          </H>
          <H viewport={viewport} className='font-size-12px font-weight-bold'>
            Uploaded Picture
          </H>
          <H viewport={viewport} className='font-size-12px font-weight-bold'>
            Delete
            <br />
            Entire Note
          </H>
        </G.Row>

        {
          /* Content */
          messages.map(
            (message): React.ReactElement => (
              // eslint-disable-next-line react/no-array-index-key
              <G.Row key={message.Timestamp_MessageID} className='row'>
                <C className='rounded-left font-size-12px font-weight-bold text-dark'>
                  {message.FirstName}
                </C>
                <C className='font-size-12px font-weight-bold text-dark'>{message.LastName}</C>
                <C className='font-size-12px font-weight-bold text-dark'>{message.Email}</C>
                <C className='font-size-12px font-weight-bold text-dark'>{message.Phone}</C>
                <C className='font-size-12px font-weight-bold text-dark message-cell'>
                  {message.Text.length > 120 ? `${message.Text.slice(0, 120)}...` : message.Text}
                  {message.Text.length > 120 && (
                    <button
                      type='button'
                      className='btn btn-link read-more-text'
                      onClick={(): void => {
                        showGuestBookMesage(message.Text);
                      }}
                    >
                      Read all
                    </button>
                  )}
                </C>
                <C className='rounded-right font-size-12px font-weight-bold text-dark'>
                  {message.ImageURL && (
                    <img
                      className='guest-book-img'
                      src={message.ImageURL}
                      alt='memorial'
                      width='150px'
                      height='auto'
                    />
                  )}
                </C>
                <C className='rounded-right font-size-12px font-weight-bold text-dark'>
                  <button
                    className='delete-btn d-flex justify-content-center align-items-center'
                    type='button'
                    onClick={(): void => {
                      handleDelete(message.Timestamp_MessageID);
                    }}
                  >
                    <div className='icon trash' />
                  </button>
                </C>
              </G.Row>
            )
          )
        }
      </G>
    </GridContainer>
  );
};
